var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 10.75V13.5H2.50008V10.75H0.666748V13.5C0.666748 14.5083 1.49175 15.3333 2.50008 15.3333H13.5001C14.5084 15.3333 15.3334 14.5083 15.3334 13.5V10.75H13.5001ZM12.5834 7.08329L11.2909 5.79079L8.91675 8.15579V0.666626H7.08342V8.15579L4.70925 5.79079L3.41675 7.08329L8.00008 11.6666L12.5834 7.08329Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.81a52e24118751295395696332462110.svg";
export { ForwardRef as ReactComponent };